export default __webpack_public_path__ + "static/media/banner-2.329f3047.png";